import { createFileRoute } from "@tanstack/react-router";
import { KontraktPodsumowanieRaportPage } from "@/features/contracts/kontrakt-podsumowanie-raport-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/raporty/podsumowanie")({
	component: KontraktPodsumowanieRaportPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.raporty-podsumowanie",
			location.pathname,
		);
	},
});
